import { useMemo } from 'react';

export const usePrivateRows = (data, isGroupByDate = false) =>
  useMemo(() => {
    if (!data || typeof data !== 'object') return [];

    return Object.entries(data).map(([title, value]) => {
      const info = value && value.shifts ? value.shifts : value;
      const resultInfo =
        isGroupByDate && info && typeof info === 'object'
          ? Object.values(info)
          : info;

      const items = (resultInfo || []).map((item) => {
        const arr = Array.isArray(item)
          ? item
          : item && item.shifts
            ? item.shifts[0]
            : [];
        if (!Array.isArray(arr) || arr.length < 5) return {};

        const [name, date, shift, description, hours] = arr;
        return { name, date, shift, description, hours };
      });

      return { title, items };
    });
  }, [data, isGroupByDate]);

export default usePrivateRows;
